/* SCEPTRE — interactions */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // -- Year stamp ------------------------------------------------
  const yr = document.getElementById('yr');
  if (yr) yr.textContent = new Date().getFullYear();

  // -- Nav + bg-video scroll state -------------------------------
  const nav = document.getElementById('nav');
  const bgWrap = document.querySelector('.bg-video');
  const scrollCue = document.querySelector('.scroll-cue');
  const hero = document.querySelector('.hero');

  const onScroll = () => {
    const y = window.scrollY;
    if (nav) {
      if (y > 24) nav.classList.add('scrolled');
      else nav.classList.remove('scrolled');
    }

    // Fade the hero background video out once the user has scrolled past
    // ~60% of the first viewport. Keep playback running so it's already
    // mid-motion if they scroll back up.
    // Measured from where the hero actually sits on screen, so it holds
    // whichever element ends up doing the scrolling.
    if (bgWrap) {
      const past = hero
        ? hero.getBoundingClientRect().bottom < window.innerHeight * 0.4
        : y > window.innerHeight * 0.6;
      bgWrap.classList.toggle('is-hidden', past);
    }

    // Fade the scroll cue once the user has clearly started scrolling.
    if (scrollCue) {
      if (y > 80) scrollCue.classList.add('is-faded');
      else scrollCue.classList.remove('is-faded');
    }
  };
  // capture: scroll events from any scrolling element, not only the window
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();

  // -- Reveal on scroll (staggered) ------------------------------
  const reveals = document.querySelectorAll('.reveal');
  const groups = new Map(); // group siblings under the same parent for stagger
  reveals.forEach(el => {
    const parent = el.parentElement;
    if (!groups.has(parent)) groups.set(parent, []);
    groups.get(parent).push(el);
  });
  groups.forEach(list => {
    list.forEach((el, i) => {
      // small per-sibling stagger
      el.style.setProperty('--d', `${i * 90}ms`);
    });
  });

  if ('IntersectionObserver' in window && !reduceMotion) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(el => io.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('is-visible'));
  }

  // -- Product flip (click arrow to swap front <-> back) ---------
  document.querySelectorAll('.product-media').forEach(media => {
    const btn = media.querySelector('.flip-btn');
    const label = btn ? btn.querySelector('.flip-label') : null;
    if (!btn) return;
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const flipped = media.classList.toggle('is-flipped');
      if (label) label.textContent = flipped ? 'Obverse' : 'Reverse';
      btn.setAttribute('aria-label', flipped ? 'Flip bar to view obverse' : 'Flip bar to view reverse');
    });
  });

  // -- Subtle pointer-tilt on product media ---------------------
  if (!reduceMotion) {
    document.querySelectorAll('.product-media').forEach(media => {
      let rect = null;
      const onMove = (e) => {
        if (!rect) rect = media.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - 0.5;
        const y = (e.clientY - rect.top) / rect.height - 0.5;
        media.style.transform = `perspective(1100px) rotateY(${x * 4}deg) rotateX(${-y * 4}deg)`;
      };
      const reset = () => {
        rect = null;
        media.style.transform = '';
      };
      media.addEventListener('mouseenter', () => { rect = media.getBoundingClientRect(); });
      media.addEventListener('mousemove', onMove);
      media.addEventListener('mouseleave', reset);
    });
  }

  // -- Smooth-scroll polish for hash links ----------------------
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', (e) => {
      const id = a.getAttribute('href');
      if (id.length < 2) return;
      const el = document.querySelector(id);
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  });

  // -- Make sure the bg video plays on iOS Low-Power / autoplay quirks ----
  const bg = document.getElementById('bgVideo');
  if (bg) {
    const tryPlay = () => bg.play().catch(() => {});
    tryPlay();
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) tryPlay();
    });
    // Some browsers need a user gesture; this kicks it as soon as one occurs
    const kick = () => { tryPlay(); window.removeEventListener('pointerdown', kick); };
    window.addEventListener('pointerdown', kick, { once: true });
  }
})();
